import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appCspViolationReporter]'
})
export class CspViolationReporterDirective implements OnInit, OnDestroy {

  private violationListener: (event: Event) => void;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.violationListener = this.handleViolation.bind(this);
  }

  ngOnInit() {
    // Listen for CSP violations
    this.renderer.listen('document', 'securitypolicyviolation', this.violationListener);
  }

  ngOnDestroy() {
    // Clean up listener (handled automatically by Angular's renderer)
  }

  private handleViolation(event: Event) {
    const violationEvent = event as any; // SecurityPolicyViolationEvent
    
    const violationData = {
      blockedURI: violationEvent.blockedURI,
      violatedDirective: violationEvent.violatedDirective,
      effectiveDirective: violationEvent.effectiveDirective,
      originalPolicy: violationEvent.originalPolicy,
      sourceFile: violationEvent.sourceFile,
      lineNumber: violationEvent.lineNumber,
      columnNumber: violationEvent.columnNumber,
      sample: violationEvent.sample,
      timestamp: new Date().toISOString()
    };

    // Log violation to console in development
    if (!document.location.hostname.includes('localhost')) {
      console.warn('CSP Violation:', violationData);
    }

    // Send violation report to monitoring service
    this.reportViolation(violationData);
  }

  private reportViolation(violationData: any) {
    // You can implement your own violation reporting service here
    // For example, send to your monitoring service, analytics, or logging service
    
    // Example: Send to a monitoring endpoint
    // fetch('/api/csp-violations', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(violationData)
    // }).catch(error => console.error('Failed to report CSP violation:', error));
    
    // For now, just log to console
    console.log('CSP Violation reported:', violationData);
  }
}
